import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {OrganizeAssetsAction} from '../constants';
export {OrganizeAssetsAction} from '../constants';

export enum FileNameCollisionStrategy {
	WARN = 0,
	REJECT = 1,
	RENAME = 2,
}

/**
 * `organizeAssets` request params
 * (what is used to send to server)
 */
export interface OrganizeAssetsRequestOptions {
	assetIds: number[];
	categoryId: number;
	action: OrganizeAssetsAction;
	collisionStrategy?: FileNameCollisionStrategy;
}

/**
 * `organizeAssets` request
 * (what gets sent to the server)
 */
export type OrganizeAssetsRequest = [
	OrganizeAssetsRequestOptions['assetIds'],
	OrganizeAssetsRequestOptions['categoryId'],
	OrganizeAssetsRequestOptions['action'],
	Required<OrganizeAssetsRequestOptions>['collisionStrategy'],
];

/**
 * `organizeAssets` response
 * (what comes back from the server)
 */
export type OrganizeAssetsResponse = SuccessResponse<OrganizeAssetsResult>;

/**
 * `organizeAssets` result
 * (what is utilized from the server response)
 */
export type OrganizeAssetsResult = string; // uuid

export const organizeAssetsEndpoint = 'organizeAssets';

/**
 * Organize assets
 * @param fetchParams Fetch params
 */
export const organizeAssets = async (
	{
		assetIds,
		categoryId,
		action,
		collisionStrategy,
	}: OrganizeAssetsRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: OrganizeAssetsRequest = [
		assetIds,
		categoryId,
		action,
		collisionStrategy ?? FileNameCollisionStrategy.WARN,
	];

	return client
		.post<OrganizeAssetsResponse>(organizeAssetsEndpoint, requestParams, {
			signal,
		})
		.then(getResponseResults);
};
export default organizeAssets;
